import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useModalStore } from '@/features/overlays/modals/modalStore';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { useFeatureFlag } from '@/api/queries/feature-flags/useFeatureFlagsQuery';

type Option = 'linkedin' | 'upload';

export const useCvStore = defineStore('cv', () => {
  const selected = ref<Option | null>(null);
  const beforeCloseCallback = ref<null | (() => void)>(null);

  const { auth } = useMeQuery();
  const { data: ffBlockResume } = useFeatureFlag('block-resume-upload');

  const shouldDisplay = computed(() => {
    const isCvNotUpdated = !auth.value?.cv_updated_at;

    if (!ffBlockResume.value) {
      return isCvNotUpdated;
    }

    return isCvNotUpdated && !ffBlockResume.value.is_active;
  });
  const alreadyUpload = computed(() => {
    return (
      !!auth.value?.cv_updated_at &&
      (auth.value?.cv_upload_status === 'completed' ||
        auth.value?.cv_upload_status === 'pending_science')
    );
  });

  function setBeforeClose(callback: (() => void) | null) {
    beforeCloseCallback.value = callback;
  }
  function runBeforeClose() {
    beforeCloseCallback.value?.();
    beforeCloseCallback.value = null;
  }

  const isOpen = computed({
    get: () => useModalStore()['cvUpload']?.visible ?? false,
    set: () => {},
  });

  function openModal() {
    useModalStore().toggle('cvUpload', undefined, true);
  }

  function closeModal() {
    useModalStore().toggle('cvUpload', undefined, false);
    reset();
  }

  function reset() {
    setTimeout(() => {
      selected.value = null;
    }, 200);
  }

  return {
    selected,
    isOpen,
    shouldDisplay,
    alreadyUpload,
    openModal,
    closeModal,
    setBeforeClose,
    runBeforeClose,
  };
});
